import { PersonalAccessToken } from "target_wasm";

export const DEFAULT_EXPIRATION_TIME = 43200;
export const CUSTOM_EXPIRATION_VALUE = -1;

export const EXPIRATION_OPTIONS = [
  { label: "1 hour", value: 60 },
  { label: "1 day", value: 1440 },
  { label: "7 days", value: 10080 },
  { label: "30 days", value: DEFAULT_EXPIRATION_TIME },
  { label: "Custom", value: CUSTOM_EXPIRATION_VALUE },
] as const;

export function sortTokens(
  tokens: PersonalAccessToken[],
): PersonalAccessToken[] {
  return tokens.slice().sort((a, b) => {
    const statusOrder = { active: 0, revoked: 1, expired: 2 };
    const aStatus = a.get_status.toLowerCase();
    const bStatus = b.get_status.toLowerCase();
    const aOrder = statusOrder[aStatus as keyof typeof statusOrder] ?? 3;
    const bOrder = statusOrder[bStatus as keyof typeof statusOrder] ?? 3;

    if (aOrder !== bOrder) {
      return aOrder - bOrder;
    }
    if (aStatus === "expired" && bStatus === "expired") {
      return Number(b.get_expires_at - a.get_expires_at);
    }

    return Number(b.get_created_at - a.get_created_at);
  });
}

export function getMinCustomDate(): string {
  return new Date().toISOString().split("T")[0];
}

export function calculateExpirationMinutesFromDate(dateString: string): number {
  const selectedDateTime = new Date(`${dateString}T00:00:00`);
  const now = new Date();
  const diffInMs = selectedDateTime.getTime() - now.getTime();
  return Math.max(Math.round(diffInMs / (1000 * 60)), 1);
}
